import _ from "lodash";
import api from "../services/api";
import odataMixin from "@/core/store/mixin/odata";

export default _.merge({}, odataMixin(api), {
  namespaced: true,
});
